// Purchase and review navigation must work independently of jQuery.
document.addEventListener('click', (event) => {
  const stickyButton = event.target.closest('#sticky-button');
  if (stickyButton) {
    event.preventDefault();
    const submit = document.querySelector('product-info[id^="MainProduct"] product-form [type="submit"]');
    if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
    stickyButton.classList.add('sticky_active');
    submit.click();
    setTimeout(() => stickyButton.classList.remove('sticky_active'), 1500);
    return;
  }

  if (event.target.closest('.product_page_cc .custom-rating')) {
    const reviews = document.getElementById('judgeme_product_reviews');
    if (!reviews) return;
    event.preventDefault();
    window.scrollTo({
      top: reviews.getBoundingClientRect().top + window.scrollY - 100,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
  }
});
